<template>
  <div class="auth-alert" :class="'auth-alert--' + variant">
    <component :is="icon" :size="16" class="auth-alert__icon" />
    <p class="auth-alert__text">{{ message }}</p>
  </div>
</template>

<script>
  import { AlertCircle, CheckCircle2, Info } from 'lucide-vue';

  const ICON_BY_VARIANT = {
    error: 'AlertCircle',
    success: 'CheckCircle2',
    info: 'Info'
  };

  export default {
    name: 'AuthAlert',
    components: {
      AlertCircle,
      CheckCircle2,
      Info
    },
    props: {
      message: {
        type: String,
        default: ''
      },
      variant: {
        type: String,
        default: 'error'
      }
    },
    computed: {
      icon() {
        return ICON_BY_VARIANT[this.variant] || ICON_BY_VARIANT.info;
      }
    }
  }
</script>

<style scoped>
.auth-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  margin-bottom: 16px;
  border: 1px solid transparent;
  border-radius: 12px;
}
.auth-alert__icon {
  flex-shrink: 0;
  margin-top: 1px;
}
.auth-alert__text {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.45;
}
.auth-alert--error {
  color: #912018;
  background: #FEF3F2;
  border-color: #FECDCA;
}
.auth-alert--success {
  color: #05603A;
  background: #ECFDF3;
  border-color: #A6F4C5;
}
.auth-alert--info {
  color: #1C2B36;
  background: #F3F6F9;
  border-color: #E0E8EF;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/auth/AuthAlert.vue